var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ShadowlessElement } from '@blocksuite/lit';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import * as icons from '../../../_common/icons/index.js';
let AffineLitIcon = class AffineLitIcon extends ShadowlessElement {
    render() {
        return html `${icons[this.name]}`;
    }
};
AffineLitIcon.styles = css `
    affine-lit-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    affine-lit-icon svg {
      fill: var(--affine-icon-color);
    }
  `;
__decorate([
    property({ attribute: false })
], AffineLitIcon.prototype, "name", void 0);
AffineLitIcon = __decorate([
    customElement('affine-lit-icon')
], AffineLitIcon);
export { AffineLitIcon };
//# sourceMappingURL=icon.js.map